import React from "react";

const ContactInfo = ({ contact }) => {
  if (!contact?.contact_telephone && !contact?.contact_email && !contact?.contact_website) {
    return null; // Don't render anything if no contact details are available
  }

  return (
    <div className="court-item-contact">
      <div className="court-contact">
        <strong>Contact: </strong>
        {contact?.contact_phone && (
          <a href={`tel:${contact.contact_phone}`} title="Call">
            📞 Telephone{" "}
          </a>
        )}
        {contact?.contact_email && (
          <a href={`mailto:${contact.contact_email}`} title="Email">
            📧 Email
          </a>
        )}
        {contact?.contact_website && (
          <a
            href={contact.contact_website}
            target="_blank"
            rel="noopener noreferrer"
            title="Visit Website"
          >
            🌐 Website
          </a>
        )}
      </div>
    </div>
  );
};

export default ContactInfo;
